import { StyleSheet } from "react-native";

const styles = StyleSheet.create({
  text: {
    //@ts-ignore
    display: "block",
  },
  copyTO: {
    marginStart: 5,
    verticalAlign: "bottom",
    zIndex: 10000,
  },
});

export default styles;
